import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


function AirplanePrebuyPage({ currentAircraft, setCurrentAircraft }) {
      const [err, setErr] = useState("");
      const selectedAircraft = currentAircraft || {};
 
      // useEffect causes an error message to be set if no current aircraft.
      // React runs this effect after every render.
      // when currentAircraft changes, it runs this code and updates the state of the error message.
      useEffect(() => {
        if (!currentAircraft) {
        setErr("No aircraft selected");
        } else {
        setErr("");
        }
      }, [currentAircraft]);
        // setErr would cause a re-render loop by itself
        // but useEffect only runs when currentAircraft changes.    

  return (
    <article className="App-article">
            {/* ============================================================
                RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}
      
              <div className="related-links">
        
                <Link to="/density-altitude">Density Altitude</Link> |
                <Link to="/cw">Crosswind/Headwind</Link> |
                <Link to="/mnvr">Maneuvers</Link> |
                <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
                <Link to="/adjustable-amortization">Aircraft Loan</Link> 
              </div>

      <h2 style={{fontSize: "38px"}}>Takeoff and Landing Data-Card</h2>
       {/* ============================================================
        HOMEPAGE INTRO / SEO SECTION
        ============================================================ */}
    <section className="home-hero">
      <h1>Airplane Prebuy Tool</h1>

      <p>
          Use this information to support your prebuy evaluation of an aircraft. <br />
          Note: This tool must not be used as a primary source for making a purchase decision,
          it is intended only as a supplementary resource to assist in organizing and visualizing information about an aircraft.
          Always verify all information with official sources, maintenance records, and a qualified mechanic 
          before making any purchase decisions. <br />
          This tool does not replace the need for a thorough prebuy inspection by a qualified mechanic,
          calculations, or safety-critical decisions. 
        </p>

         {err && <div className="error-text">{err}</div>}

        {!currentAircraft && (
          <div className="error-text">
            No aircraft is currently selected.
          </div>
        )}
    </section>

       <main className="airframe-powerplant-page">
            <section className="airframe-powerplant-card">
            <h2>
                    {selectedAircraft.tailNumber || "Selected Aircraft"}{" "}
                    {selectedAircraft.makeModel || ""}
            </h2>
      
              <table className="airframe-powerplant-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Description</th>
                    <th>Date Overhaul</th>
                    <th>Date Repaired</th>
                  </tr>
                </thead>
      
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Electric Fuel Pump</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>2</td>
                    <td>Mechanical Fuel Pump</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>3</td>
                    <td>Propeller</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>4</td>
                    <td>Fuel Servo</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>5</td>
                    <td>Alternator</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>6</td>
                    <td>Left Magneto</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Right Magneto</td>
                    <td></td>
                    <td></td>
                  </tr>
      
                  <tr>
                    <td>8</td>
                    <td>Electronic Ignition</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Propeller Governor</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Voltage Regulator</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Cylinder Replacement</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Factory or Field-Overhaul</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Oil analysis</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Oil internal screen check. Check for metal particles.</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Vacuum System/Pump</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>Cable assemblies for prop, mixture, and throttle</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Carburetor</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>Fuel Injectors and spider</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td>Fuel Lines</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>Oil Cooler Exchanger and Lines</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>21</td>
                    <td>Air Intake and Filter</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td>Connecting Rod Bearings</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td>Elevator/Rudder cable assemblies</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>24</td>
                    <td>Aileron cable or control rods</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>25</td>
                    <td>Articulating Empennage</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>26</td>
                    <td>Corrosion</td>
                    <td ></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>27</td>
                    <td>Wet Fuel Cells sealing</td>
                    <td ></td>
                    <td></td>
                  </tr>

                </tbody>
              </table>
      
              
      
              
      
              <div className="related-links">
                <Link to="/">Home</Link> |
                <Link to="/rollout">Ground Roll</Link> |
                <Link to="/navlog">NavLog</Link> |
                <Link to="/wtbals">Weight & Balance</Link> |
                <Link to="/density-altitude">Density Altitude</Link> |
                <Link to="/cw">Crosswind/Headwind</Link> |
                <Link to="/mnvr">Maneuvers</Link> |
                <Link to="/airframe-powerplant">Airframe & Powerplant</Link> |
                <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
                <Link to="/adjustable-amortization">Aircraft Loan</Link>
              </div>
            </section>
          </main>
        
      
    
    </article>
  );
}

export default AirplanePrebuyPage;
